if ( typeof MainHeader !== 'function' ) {

	class MainHeader extends HTMLElement {

		constructor(){
			super();
			this.mount();
		}

		mount(){

			/* -- > DRAWERS < -- */

			// Sticky header

			if ( this.hasAttribute('data-sticky-header') ) {

				const stickyHeader = document.createElement('div');
				stickyHeader.classList = 'sticky-header'
				stickyHeader.setAttribute('data-js-inert', '');

				const topBar = this.querySelector('.header__top');
				const bottomBar = this.querySelector('.header__bottom');

				if ( this.classList.contains('site-header--meganav') || ! bottomBar ) {
					stickyHeader.classList.add('sticky-header--meganav');
					stickyHeader.innerHTML = `<div class="site-header header__top header__top--meganav container--large">
						${topBar.innerHTML}
					</div>`;
				} else {
					stickyHeader.innerHTML = `<div class="header__bottom header-container container--large portable-hide">
						${bottomBar.innerHTML}
					</div>
					<div class="site-header header__top container--large">
						${topBar.innerHTML}
					</div>`;
				}

				document.body.append(stickyHeader);

				if ( this.querySelector('.button--cart-handle') && stickyHeader.querySelector('.header-actions') ) {
					const stickyActions = stickyHeader.querySelector('.header-actions--buttons') || stickyHeader.querySelector('.header-actions');
					if ( stickyActions && ! stickyActions.querySelector('.button--cart-handle') ) {
						stickyActions.append(this.querySelector('.button--cart-handle').cloneNode(true));
					}
				}

				stickyHeader.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-sticky`;
				})
				stickyHeader.querySelectorAll('[aria-controls]').forEach(elm=>{
					if ( ! ( elm.hasAttribute('data-js-sidebar-handle') || elm.hasAttribute('data-modal') ) ) {
						elm.setAttribute('aria-controls', `${elm.getAttribute('aria-controls')}-sticky`);
					}
				})

				window.lst = window.scrollY;
				window.lhp = 0;

				const stickyHeaderDeskBound = bottomBar || topBar;
				const stickyHeaderMobileBound = topBar;

				this.SCROLL_StickyHelper = () =>{
					
					var st = window.scrollY;
					if ( ( st <= 0 || ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top >= 0 : stickyHeaderMobileBound.getBoundingClientRect().top >= 0 ) ) && stickyHeader.classList.contains('show') ) {
						stickyHeader.classList.remove('show');
						return;
					}

					if ( st < 0 || Math.abs(lst - st) <= 5 )
						return;	

					if ( st > window.lhp ) {

						if ( st == 0 && stickyHeader.classList.contains('show') ) {

							stickyHeader.classList.remove('show');

						} else if ( st <= lst && ! stickyHeader.classList.contains('show') ) {

							window.lhp = stickyHeader.offsetTop;
							if ( ( window.innerWidth >= 1024 ? stickyHeaderDeskBound.getBoundingClientRect().top : stickyHeaderMobileBound.getBoundingClientRect().top ) < -100 ) {
								stickyHeader.classList.add('show');
							}

						} else if ( st > lst && stickyHeader.classList.contains('show') ) {
							stickyHeader.classList.remove('show');
						}

					} 

					window.lst = st;

				}

				window.addEventListener('scroll', this.SCROLL_StickyHelper, {passive:true});
				
			}

			// drawer cart connections

			document.querySelectorAll('[data-js-sidebar-handle]').forEach(elm => {
				if ( elm.hasAttribute('aria-controls') ) {
					const elmSidebar = document.getElementById(elm.getAttribute('aria-controls'));
					elm.addEventListener('click', e=>{
						e.preventDefault();
						elm.setAttribute('aria-expanded', 'true');
						elmSidebar.show();
					})
					elm.addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							elm.setAttribute('aria-expanded', 'true');
							elmSidebar.show();
							window.lastFocusedElm = elm;
							elmSidebar.querySelector('[data-js-close]').focus();
						}
					})
				}
			})
			
			// closing drawers

			document.querySelectorAll('sidebar-drawer [data-js-close]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( window.lastFocusedElm ) {
							setTimeout(()=>{
								window.lastFocusedElm.focus();
								window.lastFocusedElm = null;
							}, 100);
						}
					}
				});
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( e.target.closest('.sidebar').classList.contains('sidebar--opened') ) {
						e.target.closest('.sidebar').hide();
					}
				});
			});
			document.querySelector('.site-overlay').addEventListener('click', ()=>{
				if ( document.querySelector('.sidebar--opened') ) {
					document.querySelector('.sidebar--opened').hide();
				}
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
						if ( window.lastFocusedElm ) {
							window.lastFocusedElm.focus();
							window.lastFocusedElm = null;
						}
					}
				}
			});

			// resizing drawers

			const rootHeight = document.getElementById('root-height');
			this.RESIZE_SidebarHelper = debounce(()=>{
				rootHeight.innerHTML = `:root {
					--window-height: ${window.innerHeight}px;
				}`;
			}, 200);
			window.addEventListener('resize', this.RESIZE_SidebarHelper);
			rootHeight.innerHTML = `:root {
				--window-height: ${window.innerHeight}px;
			}`;

			// Inert elements

			document.querySelectorAll('#main > div').forEach(elm=>{
				if ( ! elm.classList.contains('inert-inside') ) {
					elm.setAttribute('data-js-inert', '');
				}
			})
			window.inertElems = document.querySelectorAll('[data-js-inert]');

			// Init modal windows

			document.querySelectorAll('[aria-controls="modal-store-selector"]').forEach(elm=>{
				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						window.lastFocusedElm = elm;
					}
				})
				elm.addEventListener('click', e=>{
					e.preventDefault();
					if ( document.querySelector('.sidebar--opened') ) {
						document.querySelector('.sidebar--opened').hide();
					}
					if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
						document.getElementById(elm.getAttribute('aria-controls')).show();
					}
				})
				elm.addEventListener('keyup', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					}
				})
			});

			// Submenu alignment

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';
			document.querySelectorAll('.site-nav.style--classic .has-submenu').forEach(elm=>{
				elm.addEventListener('mouseover', ()=>{
					if ( elm.querySelector('.normal-menu') ) {
						elm.querySelector('.normal-menu').style.left = `${rtl ? elm.getBoundingClientRect().right : elm.getBoundingClientRect().left}px`;
					}
				})
			});

			// Meganav drawer positioning (full / compact)
			const positionMegaDrawers = (trigger) => {
				const headerEl = document.getElementById('site-header');
				const sticky = document.querySelector('.sticky-header.show');
				const topEdge = sticky
					? sticky.getBoundingClientRect().bottom
					: (headerEl ? headerEl.getBoundingClientRect().bottom : 0);
				document.documentElement.style.setProperty('--meganav-drawer-top', `${Math.max(topEdge, 0)}px`);

				const drawer = trigger.querySelector(':scope > .submenu.mega-drawer');
				if ( ! drawer ) return;

				if ( drawer.classList.contains('mega-drawer--compact') ) {
					const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
					const maxWidthVar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--theme-max-width')) || 1680;
					const sidePad = (viewportWidth >= 1024 && viewportWidth <= 1439) ? 24 : 40;
					const containerWidth = Math.min(maxWidthVar, viewportWidth);
					const containerLeft = Math.max(0, (viewportWidth - containerWidth) / 2);
					const contentRight = containerLeft + containerWidth - sidePad;
					const contentLeft = containerLeft + sidePad;
					const maxDrawerWidth = Math.max(420, contentRight - contentLeft);

					// Align to grid content right edge (same as top-nav icons), not viewport edge
					drawer.style.left = 'auto';
					drawer.style.right = `${Math.max(0, viewportWidth - contentRight)}px`;
					drawer.style.width = 'max-content';
					drawer.style.maxWidth = `${maxDrawerWidth}px`;
					drawer.style.minWidth = '420px';
				} else {
					drawer.style.left = '0px';
					drawer.style.right = 'auto';
					drawer.style.width = '100vw';
					drawer.style.maxWidth = '100vw';
					drawer.style.minWidth = '';
				}
			};

			// Meganav hover open/close is CSS (:hover / :has(:focus-visible) / .focus).
			// Desktop mouseenter only positions — it does not toggle open state.
			document.querySelectorAll('.site-nav.style--classic .mega-drawer-trigger').forEach(elm=>{
				const link = elm.querySelector(':scope > a');

				elm.addEventListener('mouseenter', ()=>{
					positionMegaDrawers(elm);
				});

				elm.addEventListener('focusin', (e)=>{
					positionMegaDrawers(elm);
					// aria only for keyboard (:focus-visible), not mouse click focus
					const focused = e.target instanceof Element ? e.target : null;
					if ( link && focused && focused.matches(':focus-visible') ) {
						link.setAttribute('aria-expanded', 'true');
					}
				});

				elm.addEventListener('focusout', (e)=>{
					if ( e.relatedTarget && elm.contains(e.relatedTarget) ) return;
					if ( link ) link.setAttribute('aria-expanded', 'false');
				});
			});

			window.addEventListener('resize', debounce(()=>{
				const openTrigger = document.querySelector(
					'.site-nav.style--classic .mega-drawer-trigger:hover, .site-nav.style--classic .mega-drawer-trigger:has(:focus-visible), .site-nav.style--classic .mega-drawer-trigger.focus'
				);
				if ( openTrigger ) positionMegaDrawers(openTrigger);
			}, 150));

			// Escape: blur keyboard focus; clear .focus for touch/Enter toggles
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const focusedTrigger = document.querySelector('.site-nav.style--classic .mega-drawer-trigger:has(:focus-visible)');
					if ( focusedTrigger ) {
						const link = focusedTrigger.querySelector(':scope > a');
						if ( link ) link.setAttribute('aria-expanded', 'false');
						if ( document.activeElement && focusedTrigger.contains(document.activeElement) ) {
							document.activeElement.blur();
						}
					}
					document.querySelectorAll('.site-nav.style--classic .has-submenu.focus').forEach(elm=>{
						elm.classList.remove('focus');
						const link = elm.querySelector(':scope > a');
						if ( link ) link.setAttribute('aria-expanded', 'false');
					});
				}
			});

			// Meganav desktop search bar
			const searchBar = document.querySelector('[data-js-meganav-search-bar]');
			const searchToggles = document.querySelectorAll('[data-js-meganav-search-toggle]');
			const searchCloseBtns = document.querySelectorAll('[data-js-meganav-search-close]');
			const searchInput = document.querySelector('[data-js-meganav-search-input]');

			const closeMeganavSearch = () => {
				if ( ! searchBar ) return;
				searchBar.hidden = true;
				searchToggles.forEach(btn=>{
					btn.setAttribute('aria-expanded', 'false');
					btn.classList.remove('is-active');
				});
				const overlay = document.getElementById('search-results-overlay-meganav');
				if ( overlay ) overlay.classList.remove('active');
			};

			const openMeganavSearch = () => {
				if ( ! searchBar ) return;
				document.querySelectorAll('.site-nav.style--classic .mega-drawer-trigger.focus').forEach(elm=>{
					elm.classList.remove('focus');
					const link = elm.querySelector(':scope > a');
					if ( link ) link.setAttribute('aria-expanded', 'false');
				});
				const headerEl = document.getElementById('site-header');
				const sticky = document.querySelector('.sticky-header.show');
				const topEdge = sticky
					? sticky.getBoundingClientRect().bottom
					: (headerEl ? headerEl.getBoundingClientRect().bottom : 72);
				document.documentElement.style.setProperty('--meganav-drawer-top', `${Math.max(topEdge, 0)}px`);
				searchBar.hidden = false;
				searchToggles.forEach(btn=>{
					btn.setAttribute('aria-expanded', 'true');
					btn.classList.add('is-active');
				});
				setTimeout(()=>{
					searchInput?.focus();
				}, 20);
			};

			searchToggles.forEach(btn=>{
				btn.addEventListener('click', e=>{
					e.preventDefault();
					if ( searchBar && ! searchBar.hidden ) {
						closeMeganavSearch();
					} else {
						openMeganavSearch();
					}
				});
			});

			searchCloseBtns.forEach(btn=>{
				btn.addEventListener('click', e=>{
					e.preventDefault();
					closeMeganavSearch();
					searchToggles[0]?.focus();
				});
			});

			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC && searchBar && ! searchBar.hidden ) {
					closeMeganavSearch();
					searchToggles[0]?.focus();
				}
			});

			// predictive search

			if ( JSON.parse(document.getElementById('shopify-features').text).predictiveSearch ) {
				document.querySelectorAll('search-form [data-js-search-input]').forEach(elm=>{
					elm.addEventListener('focus', ()=>{
						document.getElementById(elm.dataset.jsFocusOverlay).classList.add('active');
						if ( ! document.body.classList.contains('predictive-script-loaded') ) {
							document.body.classList.add('predictive-script-loaded')
							const predictiveSearchJS = document.createElement('script');
							predictiveSearchJS.src = KROWN.settings.predictive_search_script;
							document.head.appendChild(predictiveSearchJS); 
						}
					})
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.TAB ) {
							if ( document.getElementById('search-results-overlay-desktop').classList.contains('active') ) {
								document.getElementById('search-results-overlay-desktop').classList.remove('active');
							}
						}
					})
				})
				window.addEventListener('load', ()=>{
					document.querySelectorAll('.search-results-overlay').forEach(elm=>{
						elm.style = '';
					})
				});
			} else {
				const searchTriggerBtn = document.querySelector('search-form [data-js-search-input] + button');
				if ( searchTriggerBtn ) {
					searchTriggerBtn.classList.add('button--invisibile-trigger');
				}
			}

			// touch navigation for the menu

			const closeTouchSubmenus = (focusedElm, focusedParent=null)=>{
				document.querySelectorAll('.style--classic li.focus').forEach(elm=>{
					if ( ! ( elm === focusedElm || elm === focusedParent ) ) {
						elm.classList.remove('focus');
					}
				})
			}
			let babyMenuTouch = false;
			document.querySelectorAll('.style--classic .has-babymenu').forEach(elm=>{
				elm.addEventListener('touchstart', ()=>{
					elm.firstElementChild.style.pointerEvents = 'none';
					elm.classList.toggle('focus');
					babyMenuTouch = true;
					closeTouchSubmenus(elm,elm.closest('.has-submenu'));
				}, { passive:true });
			})
			document.querySelectorAll('.style--classic .has-submenu').forEach(elm=>{
				if ( ! elm.classList.contains('mega-link') ) {
					elm.addEventListener('touchstart', ()=>{
						elm.firstElementChild.style.pointerEvents = 'none';
						if ( ! babyMenuTouch ) {
							elm.classList.toggle('focus');
							closeTouchSubmenus(elm);
							if ( elm.classList.contains('mega-drawer-trigger') && elm.classList.contains('focus') ) {
								positionMegaDrawers(elm);
							}
						}
						babyMenuTouch = false;
					}, { passive:true });
				}
			})

			// tab navigation for the menu

			document.querySelectorAll('.site-nav.style--classic .has-submenu > a').forEach(childEl=>{

				const elm = childEl.parentNode;
				const elmMenu = document.getElementById(childEl.getAttribute('aria-controls'));

				elm.addEventListener('keydown', e=>{

					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							e.target.setAttribute('aria-expanded', 'true');
							if ( elm.classList.contains('mega-drawer-trigger') ) {
								positionMegaDrawers(elm);
							}
						} else if ( document.activeElement.parentNode.classList.contains('has-submenu') && elm.classList.contains('focus') ) {
							elm.classList.remove('focus');
							e.target.setAttribute('aria-expanded', 'false');
						}
					}
				});	
				
				const lastFocusTarget = elm.querySelector('.mega-drawer__feature:last-child, .mega-drawer__links li:last-child a, .submenu-holder > li:last-child a');
				if ( lastFocusTarget ) {
					lastFocusTarget.addEventListener('focusout', e=>{
						if ( elm.classList.contains('focus') && ! elm.contains(e.relatedTarget) ) {
							elm.classList.remove('focus');
							childEl.setAttribute('aria-expanded', 'false');
						}
					});
				}

			});

			document.querySelectorAll('.site-nav.style--classic .has-babymenu:not(.mega-link) > a').forEach(childEl=>{	

				const elm = childEl.parentNode;
				const elmMenu = document.getElementById(childEl.dataset.ariaControls);

				elm.addEventListener('keydown', e=>{
					if ( e.keyCode == window.KEYCODES.RETURN ) {
						if ( ! e.target.classList.contains('no-focus-link') ) {
							e.preventDefault();
						}
						if ( ! elm.classList.contains('focus') ) {
							elm.classList.add('focus');
							e.target.setAttribute('aria-expanded', 'true');
							//elmMenu.setAttribute('aria-hidden', 'false');
						} else {
							elm.classList.remove('focus');
							e.target.setAttribute('aria-expanded', 'false');
							//elmMenu.setAttribute('aria-hidden', 'true');
						}
					}
				});

				if ( elm.querySelector('.babymenu li:last-child a') ) {
					elm.querySelector('.babymenu li:last-child a').addEventListener('focusout', e=>{
						if ( elm.parentNode.classList.contains('focus') ) {
							elm.parentNode.classList.remove('focus');
							elm.parentNode.setAttribute('aria-expanded', 'false');
						}
					});
				}

			})

		}

		unmount(){
			window.removeEventListener('resize', this.RESIZE_SidebarHelper);
		}

	}
	
  if ( typeof customElements.get('main-header') == 'undefined' ) {
		customElements.define('main-header', MainHeader);
	}

}

if ( typeof SidebarDrawer !== 'function' ) {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
			this.querySelector('[data-js-close]').addEventListener('click', ()=>{
				this.hide();
			});
			document.addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.ESC ) {
					const openedSidebar = document.querySelector('sidebar-drawer.sidebar--opened');
					if ( openedSidebar ){
						openedSidebar.hide();
					}
				}
			});
		}

		/* 
			* generic hide/show functions 
		*/

		show(){

			this.opened = true;
			this.removeAttribute('aria-hidden');
			document.body.classList.add('sidebar-opened');
			if ( this.classList.contains('sidebar--right') ) {
				document.body.classList.add('sidebar-opened--right');
			} else if ( this.classList.contains('sidebar--left') ) {
				document.body.classList.add('sidebar-opened--left');
			}
			this.style.display = this.classList.contains('sidebar--meganav') ? 'flex' : 'grid';
			setTimeout(()=>{
				this.classList.add('sidebar--opened');
				window.inertElems.forEach(elm=>{
					elm.setAttribute('inert', '');
				})
			}, 15);
			if ( this.id == "site-cart-sidebar" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}

		}

		hide(){

			this.opened = false;
			this.classList.remove('sidebar--opened');

			document.body.classList.remove('sidebar-opened');
			document.body.classList.remove('sidebar-opened--left');
			document.body.classList.remove('sidebar-opened--right');
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			})

			document.querySelector(`[aria-controls="${this.id}"]`)?.setAttribute('aria-expanded', 'false');

			setTimeout(()=>{
				this.style.display = 'none';
			}, 501);

		}

	}


  if ( typeof customElements.get('sidebar-drawer') == 'undefined' ) {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

if ( typeof MobileNavigation !== 'function' ) {
		
	class MobileNavigation extends HTMLElement {

		constructor() {

			super();

			const isAccordion = this.classList.contains('mobile-navigation--accordion');

			if ( isAccordion ) {
				this.querySelectorAll('.has-submenu > a').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						const item = e.target.closest('li');
						const willOpen = ! item.classList.contains('opened');
						this.querySelectorAll('.has-submenu.opened').forEach(openItem=>{
							if ( openItem !== item ) {
								openItem.classList.remove('opened');
								const openLink = openItem.querySelector(':scope > a');
								if ( openLink ) openLink.setAttribute('aria-expanded', 'false');
							}
						});
						item.classList.toggle('opened', willOpen);
						elm.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
					});
				});
			} else {
				this._openedFirstSubmenu = false;
				this._openedSecondSubmenu = false;

				this.querySelectorAll('.has-submenu > a').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! this._openedFirstSubmenu ) {
							this._openedFirstSubmenu = true;
							this.classList.add('opened-first-submenu');
							this.closest('sidebar-drawer').scrollTo({top: 0});
						}
						e.target.closest('li').classList.add('opened');
						this._resizeContainer();
					})
				});

				this.querySelectorAll('.has-babymenu > a').forEach(elm=>{
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( ! this._openedSecondSubmenu ) {
							this._openedSecondSubmenu = true;
							this.classList.add('opened-second-submenu');
							this.closest('sidebar-drawer').scrollTo({top: 0});
						}
						e.target.closest('li').classList.add('opened');
						this._resizeContainer();
					})
				});

				this.querySelectorAll('.submenu-back a').forEach(elm=>{
					elm.addEventListener('click', e=>{
						if ( this._openedSecondSubmenu ) {
							this._openedSecondSubmenu = false;
							this.classList.remove('opened-second-submenu');
							this._resizeContainer();
						} else if ( this._openedFirstSubmenu ) {
							this._openedFirstSubmenu = false;
							this.classList.remove('opened-first-submenu');
							this._resizeContainer(true);
						}
						this.closest('sidebar-drawer').scrollTo({top: 0});
						setTimeout(()=>{
							e.target.closest('li.opened').classList.remove('opened');
						}, 301);
						e.preventDefault();
					})
				});
			}

			if ( this.dataset.showHeaderActions == 'true' && document.querySelector('[data-js-header-actions]') ) {

				const mobileNavActions = document.createElement('div');
				mobileNavActions.classList = "header-actions flex-buttons";
				mobileNavActions.innerHTML = document.querySelector('[data-js-header-actions]').innerHTML;
				const nav = this.querySelector('nav');
				if ( nav ) {
					nav.prepend(mobileNavActions);
				}

				mobileNavActions.querySelectorAll('[id]').forEach(elm=>{
					elm.id = `${elm.id}-mobile`;
				});
				mobileNavActions.querySelectorAll('[data-modal]').forEach(elm=>{
					elm.addEventListener('keydown', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							window.lastFocusedElm = elm;
						}
					})
					elm.addEventListener('click', e=>{
						e.preventDefault();
						if ( document.querySelector('.sidebar--opened') ) {
							document.querySelector('.sidebar--opened').hide();
						}
						if ( document.getElementById(elm.getAttribute('aria-controls')) ) {
							document.getElementById(elm.getAttribute('aria-controls')).show();
						}
					})
				});
				
			}

		}

		_resizeContainer(main=false){
      if ( main ) {
				this.style.height = `auto`;
      } else {
				if ( this._openedSecondSubmenu ) {
					this.style.height = `${this.querySelector('.has-babymenu.opened .babymenu').scrollHeight}px`;
				} else if ( this._openedFirstSubmenu ) {
					this.style.height = `${this.querySelector('.has-submenu.opened .submenu').scrollHeight}px`;
				}  
      }
		}

	}

  if ( typeof customElements.get('mobile-navigation') == 'undefined' ) {
		customElements.define('mobile-navigation', MobileNavigation);
	}

}

if ( typeof ScrollableNavigation !== 'function' ) {

	class ScrollableNavigation extends HTMLElement {

		constructor() {

			super();

			this.linkList = this.querySelector('.link-list');
			this.header = this.parentNode;
			window.addEventListener('resize', debounce(()=>{
				this.checkNav();
			}, 200));
			this.checkNav();

			const rtl = document.documentElement.getAttribute('dir') == 'rtl';

			this.parentNode.querySelector('.scrollable-navigation-button--left').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft - (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})
			this.parentNode.querySelector('.scrollable-navigation-button--right').addEventListener('click', ()=>{
				this.scroll({
					top: 0,
					left: this.scrollLeft + (rtl ? -100 : 100),
					behavior: 'smooth'
				});
			})

		}

		checkNav() {
			if ( this.linkList.scrollWidth > this.offsetWidth ) {
				this.header.classList.add('scrolling-navigation-enabled');
			} else {
				this.header.classList.remove('scrolling-navigation-enabled');
			}
		}
		
	}

  if ( typeof customElements.get('scrollable-navigation') == 'undefined' ) {
		customElements.define('scrollable-navigation', ScrollableNavigation);
	}

}